const config = {
  apiBaseUrl: "https://eduplusazureapi.azurewebsites.net/",
};

export default config;
